module.exports = __webpack_public_path__ + "static/media/img-6.e8446b4f.jpg";